var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8673 12.3919L16.6306 12.3914C16.0902 12.3914 15.6522 12.8293 15.6522 13.3696V17.2787C15.6522 17.819 16.0902 18.257 16.6305 18.257H23.5215C22.7669 20.2153 21.3585 21.8552 19.5617 22.8973L22.5 27.9837C27.2134 25.2578 30 20.4748 30 15.1207C30 14.3583 29.9438 13.8133 29.8314 13.1997C29.746 12.7334 29.3412 12.3919 28.8673 12.3919Z",
    fill: "#167EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.1306C11.6277 24.1306 8.68368 22.2881 7.10252 19.5615L2.01624 22.4932C4.60461 26.9793 9.45348 30.0002 15 30.0002C17.7209 30.0002 20.2883 29.2676 22.5 27.9909V27.9839L19.5617 22.8974C18.2176 23.6769 16.6623 24.1306 15 24.1306Z",
    fill: "#12B347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.9908V27.9839L19.5617 22.8973C18.2177 23.6768 16.6625 24.1306 15 24.1306V30.0001C17.7209 30.0001 20.2884 29.2675 22.5 27.9908Z",
    fill: "#0F993E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86957 15.0001C5.86957 13.3379 6.3232 11.7827 7.10256 10.4388L2.01627 7.50708C0.732539 9.71179 0 12.2722 0 15.0001C0 17.728 0.732539 20.2884 2.01627 22.4931L7.10256 19.5615C6.3232 18.2175 5.86957 16.6624 5.86957 15.0001Z",
    fill: "#FFD500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.86957C17.199 5.86957 19.219 6.65098 20.7968 7.95076C21.186 8.27139 21.7517 8.24824 22.1083 7.8917L24.878 5.12197C25.2825 4.71744 25.2537 4.05527 24.8216 3.68039C22.1781 1.38709 18.7387 0 15 0C9.45348 0 4.60461 3.02092 2.01624 7.50697L7.10252 10.4387C8.68368 7.71211 11.6277 5.86957 15 5.86957Z",
    fill: "#FF4B26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7968 7.95076C21.186 8.27139 21.7518 8.24824 22.1083 7.8917L24.878 5.12197C25.2825 4.71744 25.2537 4.05527 24.8216 3.68039C22.1781 1.38703 18.7387 0 15 0V5.86957C17.199 5.86957 19.219 6.65098 20.7968 7.95076Z",
    fill: "#D93F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4cba9abef3d2523df3fbdd9f587fca6e.svg";
export { ForwardRef as ReactComponent };